import Vue from "vue";
import VueRouter from "vue-router";

Vue.prototype.$isWeiXin = (function() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  let ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
})();

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    name: "home",
    path: "/home",
    component: () => import("@/pages/home/index"),
  },
  {
    name: "configure",
    path: "/configure",
    component: () => import("@/pages/home/config"),
  },
  {
    name: "bind",
    path: "/bind",
    component: () => import("@/pages/bind/index"),
  },
  {
    name: "login",
    path: "/login",
    component: () => import("@/pages/login"),
  },
  {
    name: "register",
    path: "/register",
    component: () => import("@/pages/register"),
  },
  {
    name: "forget",
    path: "/forget",
    component: () => import("@/pages/forget"),
  },
  {
    name: "pay",
    path: "/pay",
    component: () => import("@/pages/pay/pay"),
  },
  {
    name: "payLog",
    path: "/payLog",
    component: () => import("@/pages/pay/log"),
  },
  {
    name: "selectObject",
    path: "/selectObject",
    component: () => import("@/pages/pay/selectObject"),
  },
  {
    name: "order",
    path: "/order",
    component: () => import("@/pages/pay/order"),
  },
  {
    name: "alipay",
    path: "/alipay",
    component: () => import("@/pages/pay/alipay"),
  },
  {
    name: "equipment",
    path: "/equipment",
    component: () => import("@/pages/equipment/index"),
  },
  {
    name: "usage",
    path: "/usage",
    component: () => import("@/pages/usage/index"),
  },
  {
    name: "usageUser",
    path: "/usageUser",
    component: () => import("@/pages/usage/usageUser"),
  },
  {
    name: "selectEquip",
    path: "/selectEquip",
    component: () => import("@/pages/usage/select"),
  },
  {
    name: "config",
    path: "/config",
    component: () => import("@/pages/config/index"),
  },
  {
    name: "control",
    path: "/control",
    component: () => import("@/pages/control/index"),
  },
  {
    name: "handleControl",
    path: "/handleControl",
    component: () => import("@/pages/control/control"),
  },
  {
    name: "auth",
    path: "/auth",
    component: () => import("@/pages/auth"),
  },
  {
    name: "power",
    path: "/power",
    component: () => import("@/pages/power/select"),
  },
  {
    name: "powerChart",
    path: "/powerChart",
    component: () => import("@/pages/power/power"),
  },
];

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const routs = new VueRouter({ routes: routes });
const whiteList = ["/register", "/forget", "/login", "/alipay"];
const blackList = [
  "/control",
  "/handleControl",
  "/selectEquip",
  "/usage",
  "/config",
  "/power",
  "/powerChart",
];
routs.beforeEach((to, form, next) => {
  let userId = localStorage.getItem("appUserId");
  let roleKey = localStorage.getItem("roleKey");
  let openid = localStorage.getItem("openId");
  let showControl = localStorage.getItem("showControl");
  // "/login" 获取地址栏值
  // if (to.path == "/login" && window.location.search) {
  //   let paramKey = "roleId";
  //   let search = window.location.search;
  //   // 判断是否已有roleId
  //   if (!localStorage.getItem(paramKey)) {
  //     // 执行获取roleId逻辑
  //     let param = {};
  //     let paramArr = [];
  //     window.location.search.split("?").forEach((item) => {
  //       if (item != "") {
  //         paramArr = item.split("&");
  //         paramArr.forEach((item) => {
  //           if (item == "") return;
  //           let obj = item.split("=");
  //           if (obj[0] && obj[1]) {
  //             param[obj[0]] = obj[1];
  //           }
  //         });
  //       }
  //     });
  //     // 存储paramKey
  //     if (param[paramKey]) {
  //       localStorage.setItem(paramKey, param[paramKey]);
  //     }
  //     // 跳转原网址
  //     window.location.href = window.location.href.split(search).join("");
  //   }
  // }

  // 白名单
  if (whiteList.includes(to.path)) {
    next();
  } else {
    // 未登录，跳转登录页面
    if (to.path != "/login" && !userId) {
      next("/login");
    }

    // 进入登录页面，如果已登录，跳转首页
    if (to.path == "/login" && userId) {
      next("/home");
    }

    // 已登录未绑定项目，跳转绑定项目页面
    if (to.path != "/bind" && userId && !roleKey) {
      next("/bind");
    }

    // 如果已登录并绑定项目，但未授权，跳转授权页面
    if (
      (to.path == "/order" || to.path == "/pay") &&
      !openid &&
      roleKey &&
      Vue.prototype.$isWeiXin
    ) {
      next("/auth");
    }

    // 没有管理员权限进入管理页面，直接跳转首页
    if (blackList.includes(to.path) && showControl == "false") {
      next("/home");
    }

    next();
  }
});

export default routs;
